<!-- SLG Comment: No File Send Support. Redirect to text dialog on buttom click -->
<button bitButton buttonType="primary" type="button" (click)="createSend(sendType.Text)">
  <i *ngIf="!hideIcon" class="bwi bwi-plus" aria-hidden="true"></i>
  {{ (hideIcon ? "createSend" : "new") | i18n }}
</button>
<bit-menu #itemOptions>
  <a bitMenuItem (click)="createSend(sendType.Text)">
    <i class="bwi bwi-file-text" slot="start" aria-hidden="true"></i>
    {{ "sendTypeText" | i18n }}
  </a>

  <a bitMenuItem (click)="createSend(sendType.File)">
    <i class="bwi bwi-file" slot="start" aria-hidden="true"></i>
    <div class="tw-flex tw-items-center tw-gap-2">
      {{ "sendTypeFile" | i18n }}
      <app-premium-badge></app-premium-badge>
    </div>
  </a>
</bit-menu>
